// removed by extract-text-webpack-plugin
module.exports = {"category-icon":"category-icon","empty":"empty"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/category-icon.style.sass
// module id = SQDF
// module chunks = 0